import { computed as f, ref as v } from "vue";
import { DeviceKind as o } from "@thehotelsnetwork/personalization-types";
const c = (e, l, i = v("left")) => ({
  imageStyles: f(() => {
    var r, n;
    if (l.value === o.Desktop && !((r = e.value) != null && r.imagePadding) || l.value === o.Mobile && !((n = e.value) != null && n.imageMobilePadding))
      return "";
    const u = l.value === o.Mobile ? e.value.imageMobilePadding : e.value.imagePadding;
    if (!u)
      return "";
    const {
      top: g,
      bottom: d,
      left: m,
      right: p,
      format: t
    } = u, a = {
      top: `${g}${t}`,
      bottom: i.value !== "top" ? `${d}${t}` : "0px",
      right: i.value !== "left" ? `${p}${t}` : "0px",
      left: i.value !== "right" ? `${m}${t}` : "0px"
    };
    return `
      padding: ${a.top} ${a.right} ${a.bottom} ${a.left};
    `;
  })
});
export {
  c as u
};
//# sourceMappingURL=popup-p-components-useImageStyles.js.map
